exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.undo-outfit[data-v-175e26d4] {\n  position: absolute;\n  top: 10px;\n  right: -130px;\n  font-size: 13px;\n  color: #fff;\n  background: #f2c0de;\n  height: 42px;\n  text-align: center;\n  width: 130px;\n  line-height: 42px;\n  transition: all 0.4s ease-out;\n}\n.undo-outfit.active[data-v-175e26d4] {\n  right: 0px;\n}", ""]);

// exports
